/**
 * Created by kachavas on 6/24/16.
 */
angular
  .module('ui-ng-ax')
  .directive('phxAxScrollToFocus', function phxAxScrollToFocus() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        
        const scrollPageToAdjustView = () => {
          var focusedElementCurrentPosition = angular.element(':focus').offset(),
              viewportHeight                = $(window).height(),
              currentScroll                 = $(window).scrollTop(),
              viewPortOffset = (attrs.phxAxScrollToFocus) ? parseInt(attrs.phxAxScrollToFocus): 100;
          if (focusedElementCurrentPosition && ((focusedElementCurrentPosition.top - currentScroll) > (viewportHeight - viewPortOffset))) {
            $(window).scrollTop(currentScroll + viewPortOffset);
          }
        };
        
        $('body').on('keyup', scrollPageToAdjustView);
      }
    }
  });


// WEBPACK FOOTER //
// phx_ax_scroll_to_focus.es.js